const v10189 = typeof location != "undefined";
var vLN01633 = 0;
function GameObject(p12766, p12767 = null, p12768 = true) {
  if (p12768 && !v10189) {
    for (var v10190 in p12766) {
      if (p12766[v10190] == null) {
        delete p12766[v10190];
      }
    }
    this._initData = p12766;
  }
  this.sid = p12767 != null && p12767 != null ? p12767 : vLN01633++;
  this.uid = p12766.uid;
  this.width = p12766.w;
  this.length = p12766.l;
  this.height = p12766.h;
  if (p12766.buildInd !== undefined) {
    this.buildInd = p12766.buildInd;
  }
  this.active = p12766.active === undefined ? !p12766.startClosed && !p12766.startDest : p12766.active;
  this.x = p12766.x;
  this.orgX = this.x;
  this.y = p12766.y;
  this.orgY = this.y;
  this.z = p12766.z;
  this.orgZ = this.z;
  if (p12766.xR !== undefined) {
    this.xR = p12766.xR;
  }
  if (p12766.yR !== undefined) {
    this.yR = p12766.yR;
  }
  if (p12766.zR !== undefined) {
    this.zR = p12766.zR;
  }
  if (p12766.d !== undefined) {
    this.dir = p12766.d;
  }
  if (p12766.fd !== undefined) {
    this.forceDir = p12766.fd;
  }
  if (p12766.src !== undefined) {
    this.src = p12766.src;
  }
  if (p12766.ramp !== undefined) {
    this.ramp = p12766.ramp;
  }
  if (p12766.ladder !== undefined) {
    this.ladder = p12766.ladder;
  }
  if (p12766.ropeLadder !== undefined) {
    this.ropeLadder = p12766.ropeLadder;
  }
  if (p12766.noShoot !== undefined) {
    this.noShoot = p12766.noShoot;
  }
  if (p12766.s !== undefined) {
    this.stepSrc = p12766.s;
  }
  if (p12766.score !== undefined) {
    this.score = p12766.score;
  }
  if (p12766.scoreP !== undefined) {
    this.scoreP = p12766.scoreP;
  }
  if (p12766.kill !== undefined) {
    this.kill = p12766.kill;
  }
  if (p12766.dummy !== undefined) {
    this.dummy = p12766.dummy;
  }
  if (p12766.noVis !== undefined) {
    this.noVis = p12766.noVis;
  }
  if (p12766.complexMesh !== undefined) {
    this.complexMesh = p12766.complexMesh;
  }
  if (p12766.penetrable !== undefined) {
    this.penetrable = p12766.penetrable;
  }
  if (p12766.health !== undefined) {
    this.health = p12766.health;
  }
  if (p12766.health !== undefined) {
    this.startHealth = p12766.health;
  }
  if (p12766.canDest !== undefined) {
    this.canDest = p12766.canDest;
  }
  if (p12766.transparent !== undefined) {
    this.transparent = p12766.transparent;
  }
  if (p12766.boost !== undefined) {
    this.boost = p12766.boost;
  }
  if (p12766.boostDr !== undefined) {
    this.boostDr = p12766.boostDr;
  }
  if (p12766.aoM !== undefined) {
    this.aoMlt = p12766.aoM;
  }
  if (p12766.team !== undefined) {
    this.team = p12766.team;
  }
  if (p12766.flag !== undefined) {
    this.flag = p12766.flag;
  }
  if (p12766.neutral !== undefined) {
    this.neutral = p12766.neutral;
  }
  if (p12766.img !== undefined) {
    this.img = p12766.img;
  }
  if (p12766.trigger !== undefined) {
    this.trigger = p12766.trigger;
  }
  if (p12766.meshRef !== undefined) {
    this.meshRef = p12766.meshRef;
  }
  if (p12766.isBorder !== undefined) {
    this.isBorder = p12766.isBorder;
  }
  if (p12766.propID !== undefined) {
    this.propID = p12766.propID;
  }
  if (p12766.noAmb !== undefined) {
    this.noAmb = p12766.noAmb;
  }
  if (p12766.tRadius !== undefined) {
    this.tRadius = p12766.tRadius;
  }
  var v10191 = p12766.respawnT != 0 && p12766.respawnT != null && p12766.respawnT < 100 ? 100 : p12766.respawnT;
  if (v10191) {
    this.respawnT = v10191;
  }
  if (p12766.respawnR !== undefined) {
    this.respawnR = p12766.respawnR;
  }
  if (v10191) {
    this.respawnTStart = v10191;
  }
  if (p12766.respawnR || v10191) {
    this.canRespawn = true;
  }
  if (p12766.breakSnd !== undefined) {
    this.breakSnd = p12766.breakSnd;
  }
  if (p12766.interface !== undefined) {
    this.interface = p12766.interface;
  }
  if (p12766.objLink !== undefined) {
    this.objLink = p12766.objLink;
  }
  if (p12766.isEvent !== undefined) {
    this.isEvent = p12766.isEvent;
  }
  if (p12766.collT !== undefined) {
    this.collT = p12766.collT;
  }
  if (p12766.spin !== undefined) {
    this.spin = p12766.spin;
  }
  if (p12766.gravity !== undefined) {
    this.gravity = p12766.gravity;
  }
  if (p12766.dynamic !== undefined) {
    this.dynamic = p12766.dynamic;
  }
  if (p12766.type !== undefined) {
    this.type = p12766.type;
  }
  if (p12766.notWallJ !== undefined) {
    this.notWallJ = p12766.notWallJ;
  }
  if (p12766.noGrapple !== undefined) {
    this.noGrapple = p12766.noGrapple;
  }
  if (p12766.noImpulse !== undefined) {
    this.noImpulse = p12766.noImpulse;
  }
  if (p12766.bounce !== undefined) {
    this.bounce = p12766.bounce;
  }
  if (p12766.crouch !== undefined) {
    this.crouch = p12766.crouch;
  }
  if (p12766.pickup !== undefined) {
    this.pickup = p12766.pickup;
  }
  if (p12766.orgPickup !== undefined) {
    this.orgPickup = p12766.orgPickup;
  }
  if (p12766.pickupRep !== undefined) {
    this.pickupRep = p12766.pickupRep;
  }
  if (p12766.pickupRand !== undefined) {
    this.pickupRand = p12766.pickupRand;
  }
  if (p12766.pickupRandGroup !== undefined) {
    this.pickupRandGroup = p12766.pickupRandGroup;
  }
  if (p12766.noMsg !== undefined) {
    this.noMsg = p12766.noMsg;
  }
  if (p12766.method !== undefined) {
    this.method = p12766.method;
  }
  if (p12766.selfDestruct !== undefined) {
    this.selfDestruct = p12766.selfDestruct;
  }
  if (p12766.actions !== undefined) {
    this.trigActions = p12766.actions;
  }
  if (p12766.actionCost !== undefined) {
    this.trigActCost = p12766.actionCost;
  }
  if (p12766.actionMethod !== undefined) {
    this.trigActM = p12766.actionMethod;
  }
  if (p12766.chance !== undefined) {
    this.trigChance = p12766.chance;
  }
  if (p12766.interfaceT !== undefined) {
    this.interfaceT = p12766.interfaceT;
  }
  if (p12766.singleUseP !== undefined) {
    this.singleUseP = p12766.singleUseP;
  }
  if (p12766.eventN !== undefined) {
    this.eventN = p12766.eventN;
    if (p12766.constE !== undefined) {
      this.trigConstE = p12766.constE || 0;
    }
    this.trigT = (p12766.constE || 1) * 1000;
    this.onInteractT = (p12766.constE || 1) * 1000;
    this.onColT = (p12766.constE || 1) * 1000;
    if (p12766.eventN) {
      this[p12766.eventN] = true;
    }
    this.uses = [];
    this.triggered = false;
    this.lastColT = 0;
  }
  if (p12766.singleUse !== undefined) {
    this.singleUse = p12766.singleUse;
  }
  if (p12766.node !== undefined) {
    this.node = p12766.node;
  }
  if (p12766.channel !== undefined) {
    this.channel = p12766.channel;
  }
  if (p12766.telCheckPoint !== undefined) {
    this.telCheckPoint = p12766.telCheckPoint;
  }
  if (p12766.telCooldown !== undefined) {
    this.telCooldown = p12766.telCooldown;
  }
  if (p12766.momentum !== undefined) {
    this.telStopMo = p12766.momentum;
  }
  if (p12766.closeable !== undefined) {
    this.closeable = p12766.closeable;
  }
  if (p12766.startClosed !== undefined) {
    this.startClosed = p12766.startClosed;
  }
  if (p12766.startDest !== undefined) {
    this.startDest = p12766.startDest;
  }
  if (p12766.spawnChance !== undefined) {
    this.spawnChance = p12766.spawnChance;
  }
  if (p12766.withdraw !== undefined) {
    this.withdrawAmnt = p12766.withdraw;
  }
  if (p12766.deposit !== undefined) {
    this.depositAmnt = p12766.deposit;
  }
  if (p12766.asset !== undefined) {
    this.assetID = p12766.asset;
  }
  if (p12766.teleporter !== undefined) {
    this.teleporter = p12766.teleporter;
  }
  if (p12766.gate !== undefined) {
    this.gate = p12766.gate;
  }
  if (p12766.mysteryBox !== undefined) {
    this.mysteryBox = p12766.mysteryBox;
  }
  if (p12766.perkMachine !== undefined) {
    this.perkMachine = p12766.perkMachine;
  }
  if (p12766.krumMachine !== undefined) {
    this.krumMachine = p12766.krumMachine;
  }
  if (p12766.perk !== undefined) {
    this.perk = p12766.perk;
  }
  if (p12766.premium !== undefined) {
    this.premium = p12766.premium;
  }
  if (p12766.teamZ !== undefined) {
    this.teamZ = p12766.teamZ;
  }
  if (p12766.noPVP !== undefined) {
    this.noPVP = p12766.noPVP;
  }
  if (p12766.kpd !== undefined) {
    this.kpd = p12766.kpd;
  }
  if (p12766.forcePVP !== undefined) {
    this.forcePVP = p12766.forcePVP;
  }
  if (p12766.kr !== undefined) {
    this.kr = p12766.kr;
  }
  if (p12766.amount !== undefined) {
    this.amount = p12766.amount;
  }
  if (p12766.bank !== undefined) {
    this.bank = p12766.bank;
  }
  if (p12766.verified !== undefined) {
    this.verified = p12766.verified;
  }
  if (p12766.partner !== undefined) {
    this.partner = p12766.partner;
  }
  if (p12766.jumpPad !== undefined) {
    this.jumpPad = p12766.jumpPad;
  }
  if (p12766.checkpoint !== undefined) {
    this.checkpoint = p12766.checkpoint;
  }
  if (p12766.enclose !== undefined) {
    this.enclose = p12766.enclose;
  }
  if (p12766.interactMsg !== undefined) {
    this.interactMsg = p12766.interactMsg;
  }
  if (p12766.wheel !== undefined) {
    this.wheel = p12766.wheel;
  }
  if (p12766.hasAnim !== undefined) {
    this.hasAnim = p12766.hasAnim;
  }
  if (p12766.scriptId !== undefined) {
    this.scriptId = p12766.scriptId;
  }
  if (p12766.noPCol !== undefined) {
    this.noPCol = p12766.noPCol;
  }
  if (p12766.complexColl !== undefined) {
    this.complexColl = p12766.complexColl;
  }
  if (p12766.noAICol !== undefined) {
    this.noAICol = p12766.noAICol;
  }
  if (p12766.redirection !== undefined) {
    this.redirection = p12766.redirection;
  }
  if (p12766.spread !== undefined) {
    this.spread = p12766.spread;
  }
  if (p12766.tag !== undefined) {
    this.tag = p12766.tag;
  }
  if (p12766.serverNode !== undefined) {
    this.serverNode = p12766.serverNode;
  }
  if (p12766.showIcon !== undefined) {
    this.showIcon = p12766.showIcon;
  }
  if (p12766.noMinimap !== undefined) {
    this.noMinimap = p12766.noMinimap;
  }
  if (p12766.noTex !== undefined) {
    this.noTex = p12766.noTex;
  }
  this.custVals = {};
}
module.exports = GameObject;